import corporate from './corporate';
import manage from './manage';
import profile from './profile';
import ecommerce from './ecommerce';
import scheduleChange from './schedule-change';
import upgrade from './upgrade';

export default {
  'corporate': corporate,
  'manage': manage,
  'profile': profile,
  'ecommerce': ecommerce,
  'scheduleChange': scheduleChange,
  'upgrade': upgrade,
};
